import { InputUI } from '@fourthwall/components';
import React from 'react';
export const ProductInfoFields = () => (React.createElement("div", { style: { marginTop: -4 } },
    React.createElement(InputUI.Suggestion, null, "In order for members to buy products you have to create members-only products under Products tab.")));
